/* eslint-disable import/prefer-default-export */
import { aquaAxios } from 'lib/utilityFunctions';
import { logRumError } from 'lib/DDRum';

import { USAGE_TARGETS_URL } from './endpoints';

/**
 * Fetches the canonical weekly usage targets grouped by grade band.
 * The endpoint requires no auth, so a plain request is used.
 * @returns {Promise<Array<{ grades: string[], targets: object }>>} The usage target bands
 * @throws {Error} If the request fails or the response has an unexpected shape; a RUM error is
 * logged before rethrowing so callers can decide how to degrade.
 */
export const fetchUsageTargets = async () => {
  try {
    const { data } = await aquaAxios(USAGE_TARGETS_URL);

    if (!Array.isArray(data?.usageTargets)) {
      throw new Error('Unexpected usage targets response shape');
    }

    return data.usageTargets;
  } catch (error) {
    logRumError('RTU: usage targets API request failed', {
      status: error?.response?.status,
      error: error?.message,
    });
    throw error;
  }
};
